import React from 'react'

import * as S from './styled'

import TimeLineItem from './timelineitem'
import {StaticImage} from "gatsby-plugin-image";

const WhoComponent = () => {

    const timeline = [
        {
            title: 'experiência',
            text: 'A RM SPORTS é uma Assessoria Esportiva com mais de 20 anos de experiência, desenvolvemos programas de treinamento nas diversas modalidades auxiliando no alcance dos objetivos dos nossos alunos. Atendemos todo tipo de público de várias idades e diferentes objetivos de forma segura e saudável de atletas iniciantes à avançados.'
        },
        {
            title: 'diferencial',
            text: 'Nosso diferencial maior é que trabalhamos com planilhas personalizadas e individualizadas respeitando o seu condicionamento e tempo disponível para a execução do treinamento. Além de promover treinamentos coletivos e simulados em Campinas e região. <br /><br /> Acreditamos que um treinamento realizado com planejamento extremamente individual, levando em consideração todas as características do atleta, são requisitos básicos para o sucesso no resultado, tudo isso sempre associado a nossos anos de experiência.'
        },
    ];

    return (
        <S.Wrapper>
            <S.Title id="quem-somos">Quem Somos</S.Title>
            <S.TimelineContainer>
                {timeline.map((data, idx) => (
                    <TimeLineItem data={data} key={idx}/>
                ))}
            </S.TimelineContainer>
            <S.CoachContent>
                <S.CoachPicture>
                    <StaticImage src="../../images/photo-coach.png" alt="Foto de nossas Coaches"/>
                </S.CoachPicture>
                <S.CoachText>
                    <h2>ROSANA MERINO</h2>
                    <p>Rosana é a HEAD Coach da RM Sports, responsável por todos os planejamentos de treino dos atletas. <br />
                        Iniciou sua carreira esportiva com apenas 4 anos de idade, ex-atleta profissional nas
                        modalidades de natação, ciclismo, triathlon e corrida de aventura. <br />
                        Treinadora com mais de 40 anos de experiência, já revelou vários talentos no esporte em diversas
                        modalidades treinando mais de 20 atleta profissionais em sua carreira. Somada a toda experiência
                        esportiva, é formada como Coaching pela IBC com 6 certificações internacionais, trabalhando com
                        o atleta não só sua evolução física mas também mental.</p>
                    <h2>VANESSA GIANINNI</h2>
                    <p>Atleta revelada pela Rosana Merino em 2001 com uma carreira brilhante no triathlon profissional
                        com títulos nacionais e internacionais: <br />
                        Bi-Campeã do Circuito Troféu Brasil de Triantlon PRO <br />
                        5 x Campeã Brasileira PRO <br />
                        7a. Mundial de Longa Distância PRO <br />
                        TOP 10 Mundial Ironman 70.3 PRO <br />
                        Melhor tempo: Ironman 9h06 e IM 70.3 4h18 <br />
                        Além de Sócia da Rosana na Assessoria, hoje trabalha toda parte administrativa, financeira,
                        gerenciamento dos atletas, marketing, colaboradores e estrutura dos eventos e treinos
                        coletivos.</p>
                </S.CoachText>
            </S.CoachContent>
        </S.Wrapper>
    );
};

export default WhoComponent;
